<template>
  <button
    class="font-bold rounded-full border border-gray-400 inline-flex items-center"
    :class="sizes[size].text"
    @click="click"
  >
    <img
      :src="image"
      :alt="`link-${generateUID()}`"
      class="mr-1"
      width="12"
      height="12"
      :class="sizes[size].icon"
      :image-lazy-load="imageLazyLoad"
    />
    <slot />
  </button>
</template>

<script setup>
const { $toast } = useNuxtApp()

defineOptions({
  name: 'AtomsButtonCopy'
})

const props = defineProps({
  text: {
    type: String,
    default: ''
  },

  size: {
    type: String,
    default: 'default',
    validator: value => ['small', 'default', 'large'].includes(value)
  },

  image: {
    type: String,
    default: '/icons/social/link.svg'
  },

  imageLazyLoad: {
    type: Boolean,
    default: false
  },

  successToast: {
    type: String,
    default: 'Link copied to clipboard'
  }
})

const size = ref(props.size)
const imageLazyLoad = ref(props.imageLazyLoad)

const sizes = {
  small: {
    text: 'text-xs px-3 py-1',
    icon: 'w-[9px] h-[9px]'
  },
  default: {
    text: 'text-sm px-4 py-2',
    icon: 'w-[12px] h-[12px]'
  },
  large: {
    text: 'text-md px-4 py-2',
    icon: 'w-[24px] h-[24px]'
  }
}

const click = () => {
  const text = props.text
  navigator.clipboard.writeText(text)
  $toast.success(props.successToast)
}
</script>
